<!-- container-xxl -->
<div class="content-wrapper p-0">
	<app-content-header [contentHeader]="contentHeader"></app-content-header>
	<div class="content-body">
		<!-- app e-commerce details start -->
		<section class="app-ecommerce-details">
			<!-- <div class="card"> -->
				<!-- Related Products starts -->
				<div>
					<div id="stepper1" class="bs-stepper horizontal-wizard-example">
						<div class="bs-stepper-header">
							<div class="step" data-target="#format1">
								<button class="step-trigger">
									<span class="bs-stepper-box">1</span>
									<span class="bs-stepper-label">
										<span class="bs-stepper-title">Proposal Format - 1</span>
										<span class="bs-stepper-subtitle"
											>Setup Proposal Format 1</span
										>
									</span>
								</button>
							</div>
							<div class="line">
								<i data-feather="chevron-right" class="font-medium-2"></i>
							</div>
							<div class="step" data-target="#format2">
								<button class="step-trigger">
									<span class="bs-stepper-box">2</span>
									<span class="bs-stepper-label">
										<span class="bs-stepper-title">Proposal Format - 2</span>
										<span class="bs-stepper-subtitle"
											>Setup Proposal Format - 2</span
										>
									</span>
								</button>
							</div>
							<!-- <div class="line">
								<i data-feather="chevron-right" class="font-medium-2"></i>
							</div> -->
							<!-- <div class="step" data-target="#format3">
								<button class="step-trigger">
									<span class="bs-stepper-box">3</span>
									<span class="bs-stepper-label">
										<span class="bs-stepper-title">Proposal Format - 3</span>
										<span class="bs-stepper-subtitle"
											>Setup Proposal Format - 3</span
										>
									</span>
								</button>
							</div> -->
							<!-- <div class="line">
								<i data-feather="chevron-right" class="font-medium-2"></i>
							</div> -->
							<!-- <div class="step" data-target="#format4">
								<button class="step-trigger">
									<span class="bs-stepper-box">4</span>
									<span class="bs-stepper-label">
										<span class="bs-stepper-title">Proposal Format - 4</span>
										<span class="bs-stepper-subtitle"
											>Setup Proposal Format - 4</span
										>
									</span>
								</button>
							</div> -->
							<div class="line">
								<i data-feather="chevron-right" class="font-medium-2"></i>
							</div>
							<!-- <div class="step" data-target="#format5">
				<button class="step-trigger">
					<span class="bs-stepper-box">5</span>
					<span class="bs-stepper-label">
					<span class="bs-stepper-title">Proposal Format - 5</span>
					<span class="bs-stepper-subtitle">Setup Proposal Format - 5</span>
					</span>
				</button>
				</div> -->
						</div>
						
						<div class="bs-stepper-content">
							<div id="format1" class="content">
								<form [formGroup]="format1" autocomplete="off">
									<!-- <div class="content-header">
					<h5 class="mb-0">Proposal Format - 1</h5>
					<small class="text-muted">Fill-up the Details.</small>
					</div> -->
					<fieldset class="border" style="padding: 0.7rem">
						<legend class="w-auto">
							<h5 style="margin-top: 7px">Submission of Proposals for CoEs</h5>
						</legend>
						<div class="row">
							
							
						
							
							<div class="form-group col-md-4">
								<label class="form-label" for="applicantCategory"
									>Applicant Category</label
								>
								<span class="required-asterisk">*</span>
					
								<ng-select
									[items]="applicantCategory"
									[(ngModel)]="selected"
									
									bindLabel="name"
									bindValue="id"
									placeholder="Applicant Category"
									[class.error]="
										!f1.ApplicantCategory.valid && submitted
									"
									formControlName="ApplicantCategory"
									(change)="
										leadPartnerOptionsSelected(selected)
									"
									[(ngModel)]="selected"
								>
								</ng-select>
								<span
									*ngIf="submitted && f1.ApplicantCategory.invalid"
									class="invalid-form"
								>
									<small
										class="form-text text-danger"
										*ngIf="f1.ApplicantCategory.errors.required"
										>This field is required!</small
									>
								</span>
							</div>

							<div class="form-group col-md-4" *ngIf="displayLeadPartnerField">
								<label class="form-label" for="leadPartner"
									>Mention lead partner with composition</label
								>
								<span class="required-asterisk">*</span>
								<input
									formControlName="LeadPartner"
									type="text"
									
									name="leadPartner"
									id="leadPartner"
									class="form-control"
									[ngClass]="{
										'is-invalid':
											submitted && !f1.LeadPartner.valid
									}"
									placeholder="Mention lead partner with composition"
									
								/>
								<span
									*ngIf="submitted && f1.LeadPartner.invalid"
									class="invalid-form"
								>
									<small
										class="form-text text-danger"
										*ngIf="f1.LeadPartner.errors.required"
										>This field is required!</small
									>
								</span>
							</div>

							
							
						</div>
						<div class="row">
							<div class="form-group col-md-4">
								<label class="form-label" for="coeTitle"
									>CoE Title</label
								>
								<span class="required-asterisk">*</span>
								<input
									formControlName="CoeTitle"
									type="text"
									name="coeTitle"
									id="coeTitle"
									class="form-control"
									[ngClass]="{
										'is-invalid': submitted && !f1.CoeTitle.valid
									}"
									placeholder="CoE Title"
								/>
								<span
									*ngIf="submitted && f1.CoeTitle.invalid"
									class="invalid-form"
								>
									<small
										class="form-text text-danger"
										*ngIf="f1.CoeTitle.errors.required"
										>This field is required!</small
									>
									<small
										class="form-text text-danger"
										*ngIf="f1.CoeTitle.errors.pattern"
										>This field contain atleast one alphanumerical
										value!</small
									>
								</span>
							</div>

							<div class="form-group col-md-4">
								<label class="form-label" for="coeTitle"
									>Total Project Cost with MNRE share
									requested (In Rs.)</label
								>
								<span class="required-asterisk">*</span>
								<input
									formControlName="TotalCostMnreShare"
									type="text"
									name="totalCostMnreShare"
									id="totalCostMnreShare"
									[mask]="'^([1-9]\\d*|0)$'"
									maxlength="15"
									class="form-control"
									[ngClass]="{
										'is-invalid': submitted && !f1.TotalCostMnreShare.valid
									}"
									placeholder="Total Project Cost with MNRE share"
								/>
								<span
									*ngIf="submitted && f1.TotalCostMnreShare.invalid"
									class="invalid-form"
								>
									<small
										class="form-text text-danger"
										*ngIf="f1.TotalCostMnreShare.errors.required"
										>This field is required!</small
									>
									
								</span>
							</div>

							<!-- <div class="form-group col-md-3">
								<label class="form-label" for="duration"
									>Duration (in Months)</label
								>
								<span class="required-asterisk">*</span>
								<input
									formControlName="Duration"
									type="text"
									name="duration"
									id="duration"
									class="form-control"
									(change)="setNoofYears(f1.Duration.value, true)"
									placeholder="Duration"
									[ngClass]="{
										'is-invalid': submitted && !f1.Duration.valid
									}"
									[mask]="'^([1-9]\\d*|0)$'"
									maxlength="4"
								/>
								<span
									*ngIf="submitted && f1.Duration.invalid"
									class="invalid-form"
								>
									<small
										class="form-text text-danger"
										*ngIf="f1.Duration.errors.required"
										>This field is required!</small
									>
								</span>
							</div> -->


							
							
						</div>
						
					</fieldset>

					<fieldset class="border" style="padding: 0.7rem" >
						<legend class="w-auto">
							<h5 style="margin-top: 7px">Principal Investigator Details</h5>
						</legend>
						<div class="row" >
							

			<div class="form-group col-md-4">
				<label class="form-label" for="piName"
					>Name</label
				>
				<span class="required-asterisk">*</span>
				<input
					formControlName="PiName"
					type="text"
					name="piName"
					id="piName"
					class="form-control"
					[ngClass]="{
						'is-invalid': submitted && !f1.PiName.valid
					}"
					placeholder="Name"
				/>
				<span
					*ngIf="submitted && f1.PiName.invalid"
					class="invalid-form"
				>
					<small
						class="form-text text-danger"
						*ngIf="f1.PiName.errors.required"
						>This field is required!</small
					>
					
				</span>
			</div>

			<div class="form-group col-md-4">
				<label class="form-label" for="piTelephone"
					>Telephone/Mobile No</label
				>
				<span class="required-asterisk">*</span>
				<input
					formControlName="PiTelephone"
					type="text"
					name="piTelephone"
					id="piTelephones"
					onKeyPress="if(this.value.length==10) return false;"
					[mask]="'^([1-9]\\d*|0)$'"
					class="form-control"
					[ngClass]="{
						'is-invalid': submitted && !f1.PiTelephone.valid
					}"
					placeholder="Telephones No"
				/>
				<span
					*ngIf="submitted && f1.PiTelephone.invalid"
					class="invalid-form"
				>
					<small
						class="form-text text-danger"
						*ngIf="f1.PiTelephone.errors.required"
						>This field is required!</small
					>
					<small
						class="form-text text-danger"
						*ngIf="f1.PiTelephone.errors.pattern"
						>Please enter a valid 10-digit telephone/mobile number!</small
					>
				</span>
			</div>

			<div class="form-group col-md-4">
				<label class="form-label" for="piFax"
					>Fax No.</label
				>
				<!-- <span class="required-asterisk">*</span> -->
				<input
					formControlName="PiFax"
					type="text"
					name="piFax"
					id="piFax"
					class="form-control"
					[ngClass]="{
						'is-invalid': submitted && !f1.PiTelephone.valid
					}"
					placeholder="Fax No"
				/>
				<span
					*ngIf="submitted && f1.PiFax.invalid"
					class="invalid-form"
				>
					<small
						class="form-text text-danger"
						*ngIf="f1.PiFax.errors.required"
						>This field is required!</small
					>
					<small
						class="form-text text-danger"
						*ngIf="f1.PiFax.errors.pattern"
						>Please enter a valid Fax No!</small
					>
				</span>
			</div>

			<div class="form-group col-md-4">
				<label class="form-label" for="piEmail"
					>Email ID</label
				>
				<span class="required-asterisk">*</span>
				<input
					formControlName="PiEmail"
					type="text"
					name="piEmail"
					id="piEmail"
					
					class="form-control"
					[ngClass]="{
						'is-invalid': submitted && !f1.PiEmail.valid
					}"
					placeholder="Email ID"
				/>
				<span
					*ngIf="submitted && f1.PiEmail.invalid"
					class="invalid-form"
				>
					<small
						class="form-text text-danger"
						*ngIf="f1.PiEmail.errors.required"
						>This field is required!</small
					>
					<small
						class="form-text text-danger"
						*ngIf="f1.PiEmail.errors.pattern"
						>Please enter a valid email Id.</small
					>
				</span>
			</div>

			<div class="form-group col-md-4">
				<label class="form-label" for="coeTitle"
					>Upload CV </label
				>
				<span class="required-asterisk">*</span>
				<div class="custom-file">
					<input
					formControlName="principaIinvestigatorCvFileName"
						type="file"
						class="custom-file-input"
						type="file"
						ng2FileSelect
						[uploader]="uploader"
						id="file-upload-single"
						
						(change) = "fileUploadpi($event)"
					/>
					<label
						class="custom-file-label"
						id="SOELatter"
						for="file-upload-single"
						>{{ f1.principaIinvestigatorCvFileName.value }}</label
					>
				</div>
				<sup>(Accepted format is Upload PDF, upto 5 MB) <span *ngIf="(f1?.principaIinvestigatorCvFile.value != '')" class="text-primary" ><a href="{{f1?.principaIinvestigatorCvFile.value}}" target="_blank">Download Document</a></span></sup>
				
				<span
					*ngIf="submitted && f1.principaIinvestigatorCvFileName.invalid"
					class="invalid-form"
				>
					<small
						class="form-text text-danger"
						*ngIf="f1.principaIinvestigatorCvFileName.errors.required"
						>This field is required!</small
					>
					
					<!-- <td *ngIf="(f1?.DetailofAnnexureFirstFile.value != '')">
						<a href="{{f1?.DetailofAnnexureFirstFile.value}}"
							target="_blank"><i
								class="feather avatar-icon font-medium-1 icon-arrow-down-circle"
								title="Download Document"></i></a>
					</td> -->
				</span>
			</div>

			

			
							
						</div>
					</fieldset>
<br>
					<!-- <div class="row"> 
						<div class="form-group col-md-4">
						<label class="form-label" for="coPrincipalDetails"
							>Have You Co-Principal Investigator Detail?</label
						>
						<span class="required-asterisk">*</span>
			
						<ng-select
							[items]="coPrincipalDetailss"
							[(ngModel)]="selectedOption"
							bindLabel="name"
							bindValue="id"
							placeholder="Have You Co-Principal Investigator Detail?"
							[class.error]="
								!f1.CoPrincipalDetails.valid && submitted
							"
							formControlName="CoPrincipalDetails"
							(change)="
								CoPrincipalOptionsSelected(selectedOption)
							"
						>
						</ng-select>
						<span
							*ngIf="submitted && f1.CoPrincipalDetails.invalid"
							class="invalid-form"
						>
							<small
								class="form-text text-danger"
								*ngIf="f1.CoPrincipalDetails.errors.required"
								>This field is required!</small
							>
						</span>
					</div></div> -->
					<!-- <fieldset class="border" style="padding: 0.7rem" *ngIf="displayCoPrincipalField" > -->
					<fieldset class="border" style="padding: 0.7rem"  >
						<legend class="w-auto">
							<h5 style="margin-top: 7px">Co-Principal Investigator Details</h5>
						</legend>
						<div class="row">
							

			<div class="form-group col-md-4">
				<label class="form-label" for="coeTitle"
					>Name</label
				>
				<!-- <span class="required-asterisk">*</span> -->
				<input
					formControlName="CoPiName"
					type="text"
					name="coPiName"
					id="coPiName"
					class="form-control"
					[ngClass]="{
						'is-invalid': submitted && !f1.CoPiName.valid
					}"
					placeholder="Name"
				/>
				<span
					*ngIf="submitted && f1.CoPiName.invalid"
					class="invalid-form"
				>
					<small
						class="form-text text-danger"
						*ngIf="f1.CoPiName.errors.required"
						>This field is required!</small
					>
					<small
						class="form-text text-danger"
						*ngIf="f1.CoPiName.errors.pattern"
						>This field contain atleast one alphanumerical
						value!</small
					>
				</span>
			</div>

			<div class="form-group col-md-4">
				<label class="form-label" for="coPiTelephone"
					>Telephone/Mobile No.</label
				>
				<!-- <span class="required-asterisk">*</span> -->
				<input
					formControlName="CoPiTelephone"
					type="text"
					name="coPiTelephone"
					id="coPiTelephone"
					onKeyPress="if(this.value.length==10) return false;"
					[mask]="'^([1-9]\\d*|0)$'"
					class="form-control"
					[ngClass]="{
						'is-invalid': submitted && !f1.PiTelephone.valid
					}"
					placeholder="Telephone/Mobile No"
				/>
				<span
					*ngIf="submitted && f1.CoPiTelephone.invalid"
					class="invalid-form"
				>
					<small
						class="form-text text-danger"
						*ngIf="f1.CoPiTelephone.errors.required"
						>This field is required!</small
					>
					<small
						class="form-text text-danger"
						*ngIf="f1.CoPiTelephone.errors.pattern"
						>Please enter a valid 10-digit telephone/mobile number!</small
					>
				</span>
			</div>

			<div class="form-group col-md-4">
				<label class="form-label" for="coPiFax"
					>Fax No.</label
				>
				<!-- <span class="required-asterisk">*</span> -->
				<input
					formControlName="CoPiFax"
					type="text"
					name="coPiFax"
					id="coPiFax"
					class="form-control"
					[ngClass]="{
						'is-invalid': submitted && !f1.CoPiFax.valid
					}"
					placeholder="Fax No"
				/>
				<span
					*ngIf="submitted && f1.CoPiFax.invalid"
					class="invalid-form"
				>
					<small
						class="form-text text-danger"
						*ngIf="f1.CoPiFax.errors.required"
						>This field is required!</small
					>
				
				</span>
			</div>

			<div class="form-group col-md-4">
				<label class="form-label" for="coeTitle"
					>Email ID</label
				>
				<!-- <span class="required-asterisk">*</span> -->
				<input
					formControlName="CoPiEmail"
					type="text"
					name="coPiEmail"
					id="coPiEmail"
					class="form-control"
					[ngClass]="{
						'is-invalid': submitted && !f1.CoPiEmail.valid
					}"
					placeholder="Email"
				/>
				<span
					*ngIf="submitted && f1.CoPiEmail.invalid"
					class="invalid-form"
				>
					<small
						class="form-text text-danger"
						*ngIf="f1.CoPiEmail.errors.required"
						>This field is required!</small
					>
					<small
						class="form-text text-danger"
						*ngIf="f1.CoPiEmail.errors.pattern"
						>Please enter a valid email Id.!</small
					>
				</span>
			</div>

			

			<div class="form-group col-md-4">
				<label class="form-label" for="coeTitle"
					>Upload CV</label
				>
				<!-- <span class="required-asterisk">*</span> -->
				<div class="custom-file">
					<input
					  formControlName="CoPrincipaIinvestigatorCvFileName"
						type="file"
						class="custom-file-input"
						type="file"
						ng2FileSelect
						[uploader]="uploader"
						id="file-upload-single"
						
						(change) = "fileUploadcopi($event)"
					/>
					<label
						class="custom-file-label"
						id="SOELatter"
						for="file-upload-single"
						>{{ f1.CoPrincipaIinvestigatorCvFileName.value }}</label
					>
				</div>
				<sup>(Accepted format is Upload PDF, upto 5 MB) <span *ngIf="(f1?.CoPrincipaIinvestigatorCvFile.value != '')" class="text-primary" ><a href="{{f1?.CoPrincipaIinvestigatorCvFile.value}}" target="_blank">Download Document</a></span></sup>
				<span
					*ngIf="submitted && f1.CoPrincipaIinvestigatorCvFileName.invalid"
					class="invalid-form"
				>
					<small
						class="form-text text-danger"
						*ngIf="f1.CoPrincipaIinvestigatorCvFileName.errors.required"
						>This field is required!</small>
				</span>
			</div>

			<div class="form-group col-md-6">
				<label class="form-label" for="coeTitle"
					><i>Enter the additional Co-Principal Investigator details in the given format</i>:<br>
					<b>Name, Mobile Number, Email</b></label
				>
				<!-- <span class="required-asterisk">*</span> -->
				<textarea
					formControlName="AdditionalCoPiDetail"
					type="text"
					name="additionalCoPiDetail"
					id="additionalCoPiDetail"
					class="form-control"
					[ngClass]="{
						'is-invalid': submitted && !f1.AdditionalCoPiDetail.valid
					}"
					placeholder="Name, Mobile Number, Email"
				></textarea>
				<!-- <sub>(5000 characters accepted) Character Count: {{ f1.StatusOfWork.value?.length || 0 }} / 5000</sub> -->
				<span
					*ngIf="submitted && f1.AdditionalCoPiDetail.invalid"
					class="invalid-form"
				>
					<small
						class="form-text text-danger"
						*ngIf="f1.AdditionalCoPiDetail.errors.required"
						>This field is required!</small
					>
					<small class="form-text text-danger"
							*ngIf="f1.AdditionalCoPiDetail.errors.maxlength">Maximum 5000 characters allowed.</small>
				</span>
			</div>

			

			
							
						</div>
					</fieldset>

				

					
									<fieldset class="border" style="padding: 0.7rem">
										<legend class="w-auto">
											<h5 style="margin-top: 7px"></h5>
										</legend>
										<div class="row">
											

							
						

							<div class="form-group col-md-4">
								<label class="form-label" for="coeTitle"
									>Substantiated with letters/agreements</label
								>
								<span class="required-asterisk">*</span>
								<div class="custom-file">
									<input
										type="file"
										class="custom-file-input"
										type="file"
										ng2FileSelect
										[uploader]="uploader"
										id="file-upload-single"
										(click)="
											browsbuttonClick(
												'substantiatedLetters'
											)
										"
										(change) = "fileUploadsubletters($event)"
									/>
									<label
										class="custom-file-label"
										id="SOELatter"
										for="file-upload-single"
										>{{ f1.SubstantiatedLettersFileName.value }}</label
									>
								</div>
								<sup>(Accepted format is Upload PDF, upto 5 MB) <span *ngIf="(f1?.SubstantiatedLettersFile.value != '')" class="text-primary" ><a href="{{f1?.SubstantiatedLettersFile.value}}" target="_blank">Download Document</a></span></sup>
								<span
									*ngIf="submitted && f1.SubstantiatedLettersFileName.invalid"
									class="invalid-form"
								>
									<small
										class="form-text text-danger"
										*ngIf="f1.SubstantiatedLettersFileName.errors.required"
										>This field is required!</small
									>
									
								</span>
							</div>

							<div class="form-group col-md-6">
								<label class="form-label" for="coeTitle"
									>Status of Work being done in other
									National/International Institutions/
									Industries<small style="font-size:10px;"> (To be properly
									referenced with citations in peer
									reviewed scientific Journals
									wherever possible):</small></label
								>
								<span class="required-asterisk">*</span>
								<textarea
									formControlName="StatusOfWork"
									type="text"
									name="statusOfWork"
									id="statusOfWork"
									class="form-control"
									[ngClass]="{
										'is-invalid': submitted && !f1.StatusOfWork.valid
									}"
									placeholder="Status of Work being done in other National/International Institutions/ Industries"
								></textarea>
								<sub>(5000 characters accepted) Character Count: {{ f1.StatusOfWork.value?.length || 0 }} / 5000</sub>
								<span
									*ngIf="submitted && f1.StatusOfWork.invalid"
									class="invalid-form"
								>
									<small
										class="form-text text-danger"
										*ngIf="f1.StatusOfWork.errors.required"
										>This field is required!</small
									>
									<small class="form-text text-danger"
											*ngIf="f1.StatusOfWork.errors.maxlength">Maximum 5000 characters allowed.</small>
								</span>
							</div>

				

							
								
											
										</div>
									</fieldset>

									<fieldset class="border" style="padding: 0.7rem">
										<legend class="w-auto">
											<h5 style="margin-top: 7px">
												
											</h5>
										</legend>
										<div class="row">

											

											<div class="form-group col-md-6">
												<label class="form-label" for="objectives"
													>Break-up of sources of balance
													cost <small style="font-size:10px;"> (including share of partner
													institutions in the total cost
													(substantiated with
													letters/agreements)</small></label
												>
												<span class="required-asterisk">*</span>
												<textarea
													formControlName="SourceBalanceCost"
													type="text"
													name="sourceBalanceCost"
													id="sourceBalanceCost"
													class="form-control"
													style="height: 200px"
													[ngClass]="{
														'is-invalid': submitted && !f1.SourceBalanceCost.valid
													}"
													placeholder="Break-up of sources of balance cost"
												></textarea>
												<sub>(5000 characters accepted) Character Count: {{ f1.SourceBalanceCost.value?.length || 0 }} / 5000</sub>
												<span
													*ngIf="submitted && f1.SourceBalanceCost.invalid"
													class="invalid-form"
												>
													<small
														class="form-text text-danger"
														*ngIf="f1.SourceBalanceCost.errors.required"
														>This field is required!</small
													>
													<small class="form-text text-danger"
														*ngIf="f1.SourceBalanceCost.errors.maxlength">Maximum 5000 characters allowed.</small>
												</span>
											</div>

											<div class="form-group col-md-6">
												<label class="form-label" for="summary"
													>Pilot Technology Development
													details (if any)</label
												>
												<!-- <span class="required-asterisk">*</span> -->
												<textarea
													formControlName="PilotTechnologyDetail"
													type="text"
													name="pilotTechnologyDetail"
													id="pilotTechnologyDetail"
													style="height: 200px"
													class="form-control"
													[ngClass]="{
														'is-invalid': submitted && !f1.PilotTechnologyDetail.valid
													}"
													placeholder="Pilot Technology Development details"
												></textarea>
												<sub>(5000 characters accepted) Character Count: {{ f1.PilotTechnologyDetail.value?.length || 0 }} / 5000</sub>
												<span
													*ngIf="submitted && f1.PilotTechnologyDetail.invalid"
													class="invalid-form"
												>
													<small
														class="form-text text-danger"
														*ngIf="f1.PilotTechnologyDetail.errors.required"
														>This field is required!</small
													>
													<small class="form-text text-danger"
														*ngIf="f1.PilotTechnologyDetail.errors.maxlength">Maximum 5000 characters allowed.</small>
												</span>
											</div>

											
										</div>
											
										
									</fieldset>
									

									<fieldset class="border" style="padding: 0.7rem">
										<legend class="w-auto">
											<h5 style="margin-top: 7px">
												
											</h5>
										</legend>
										<div class="row">

											

											<div class="form-group col-md-6">
												<label class="form-label" for="objectives"
													>Objectives</label
												>
												<span class="required-asterisk">*</span>
												<textarea
													formControlName="Objectives"
													type="text"
													name="objectives"
													id="objectives"
													class="form-control"
													style="height: 200px"
													[ngClass]="{
														'is-invalid': submitted && !f1.Objectives.valid
													}"
													placeholder="Objectives"
												></textarea>
												<sub>(5000 characters accepted) Character Count: {{ f1.Objectives.value?.length || 0 }} / 5000</sub>
												<span
													*ngIf="submitted && f1.Objectives.invalid"
													class="invalid-form"
												>
													<small
														class="form-text text-danger"
														*ngIf="f1.Objectives.errors.required"
														>This field is required!</small
													>
													<small class="form-text text-danger"
														*ngIf="f1.Objectives.errors.maxlength">Maximum 5000 characters allowed.</small>
														
														
												</span>
											</div>

											<div class="form-group col-md-6">
												<label class="form-label" for="summary"
													>Summary (About a paragraph)</label
												>
												<span class="required-asterisk">*</span>
												<textarea
													formControlName="Summary"
													type="text"
													name="summary"
													id="summary"
													style="height: 200px"
													class="form-control"
													[ngClass]="{
														'is-invalid': submitted && !f1.Summary.valid
													}"
													placeholder="Summary"
												></textarea>
												<sub>(5000 characters accepted) Character Count: {{ f1.Summary.value?.length || 0 }} / 5000</sub>
												<span
													*ngIf="submitted && f1.Summary.invalid"
													class="invalid-form"
												>
													<small
														class="form-text text-danger"
														*ngIf="f1.Summary.errors.required"
														>This field is required!</small
													>
													<small class="form-text text-danger"
														*ngIf="f1.Summary.errors.maxlength">Maximum 5000 characters allowed.</small>
												</span>
											</div>

											<div class="form-group col-md-6">
												<label class="form-label" for="timelines"
													>Timelines (in terms of Work Plan)</label
												>
												<span class="required-asterisk">*</span>
												<textarea
													formControlName="Timelines"
													type="text"
													name="timelines"
													id="timelines"
													style="height: 200px"
													class="form-control"
													[ngClass]="{
														'is-invalid': submitted && !f1.Timelines.valid
													}"
													placeholder="Timelines"
												></textarea>
												<sub>(5000 characters accepted) Character Count: {{ f1.Timelines.value?.length || 0 }} / 5000</sub>
												<span
													*ngIf="submitted && f1.Timelines.invalid"
													class="invalid-form"
												>
													<small
														class="form-text text-danger"
														*ngIf="f1.Timelines.errors.required"
														>This field is required!</small
													>
													<small class="form-text text-danger"
														*ngIf="f1.Timelines.errors.maxlength">Maximum 5000 characters allowed.</small>
												</span>
											</div>
											

											<div class="form-group col-md-6">
												<label class="form-label" for="detailFunctioning"
													>Details of functioning of CoE</label
												>
												<span class="required-asterisk">*</span>
												<textarea
													formControlName="DetailFunctioning"
													type="text"
													name="detailFunctioning"
													id="detailFunctioning"
													style="height: 200px"
													class="form-control"
													[ngClass]="{
														'is-invalid': submitted && !f1.DetailFunctioning.valid
													}"
													placeholder="Details of functioning of CoE"
												></textarea>
												<sub>(5000 characters accepted) Character Count: {{ f1.DetailFunctioning.value?.length || 0 }} / 5000</sub>
												<span
													*ngIf="submitted && f1.DetailFunctioning.invalid"
													class="invalid-form"
												>
													<small
														class="form-text text-danger"
														*ngIf="f1.DetailFunctioning.errors.required"
														>This field is required!</small
													>
													<small class="form-text text-danger"
														*ngIf="f1.DetailFunctioning.errors.maxlength">Maximum 5000 characters allowed.</small>
												</span>

											</div>
											

											


											
										</div>
											
										
									</fieldset>

									
									<div
										class="d-flex justify-content-between"
										style="margin-top: 7px"
									>
										<!-- <button
											(click)="horizontalWizardStepperPrevious()"
											class="btn btn-outline-secondary btn-prev"
											disabled
											rippleEffect
										>
											<i
												data-feather="arrow-left"
												class="align-middle mr-sm-25 mr-0"
											></i>
											<span class="align-middle d-sm-inline-block d-none"
												>Previous</span
											>
										</button>
										<button *ngIf="!hideButton"
											(click)="submitStep1()"
											type="submit"
											class="btn btn-primary btn-next"
											rippleEffect
										>
											<span class="align-middle d-sm-inline-block d-none"
												>Save & Next</span
											>
											<i
												data-feather="arrow-right"
												class="align-middle ml-sm-25 ml-0"
											></i>
										</button> -->
									</div>
								</form>
							</div>
							<div id="format2" class="content">
								<form [formGroup]="format2" autocomplete="off">
									<div class="content-header">
										<h5 class="mb-0">Proposal Format - 2</h5>
										<small class="text-muted">Fill-up the Details.</small>
									</div>

									

									<div
										class="row"
										id="table-responsive"
										style="margin-top: 5px"
									>
										<div class="form-group col-12">
											<div class="table-responsive table-bordered">
												<form
													[formGroup]="proposedCostForm"
													*ngIf="proposedCostForm"
												>
													<table class="table mb-0">
														<thead>
															<tr>
																<th scope="col" class="text-wrap" rowspan="2">
																	Proposed cost: (Details of equipment along
																	with justification to be provided separately
																	in the Format as per Annexure I)
																</th>
																<th scope="col" class="text-wrap" rowspan="2">
																	SR. No.
																</th>
																<th scope="col" class="text-wrap" rowspan="2">
																	Item
																</th>
																<th scope="col" class="text-wrap"  rowspan="2">
																	Total Cost
																</th>
																<th
																	scope="col"
																	class="text-wrap"
																	style="text-align: center"
																	[attr.colspan]="noOfYeararray.length"
																>
																	Amount (Rs.)
																</th>
															</tr>

															<tr>
																<th scope="col" class="text-wrap"  *ngFor="let y of noOfYeararray">
																	{{y.key}}
																</th>
															</tr>
														</thead>
														 <tbody formArrayName="proposedCostArray">
															<tr *ngFor="let item of proposedCostForm.controls.proposedCostArray.controls;let $index = index" [formGroupName]="$index">
																<td *ngIf="$index == 0" [attr.rowspan]="proposedCostForm.controls.proposedCostArray.length"></td>
																<td scope="col" class="text-wrap">
																	{{ $index + 1 }}.
																</td>
																<td scope="col" class="text-wrap">
																	<span>{{
																		proposedCostForm.controls[
																			"proposedCostArray"
																		].controls[$index].controls[
																			"proposedCostItemName"
																		].value
																	}}</span>
																</td>
																<td scope="col" class="text-wrap">
																	<input
																		type="hidden"
																		formControlName="proposedCostItemID"
																	/>
																	<span>{{
																		proposedCostForm.controls[
																			"proposedCostArray"
																		].controls[$index].controls["totalCost"]
																			.value
																	}}</span>
																</td>
																<td scope="col" class="text-wrap" *ngFor="let y of noOfYeararray; let $index1 = index1">
																	<input
																		class="form-control"
																		type="text"
																		curencyFormat
																		formControlName="{{y.label}}"
																		[mask]="
																			'^[+]?([1-9]\\d*|0)?(\\.\\d\{0,2\})?$'
																		"
																		onKeyPress="if(this.value.length==15) return false;"
																		(change)="setAllFieldTotal($index)"
																	/>
																	
																</td>
														<tr>
															<td style="border-top: none"></td>
															<td scope="col" class="text-wrap">Total</td>
															<td scope="col" class="text-wrap"></td>
															<td scope="col" class="text-wrap">
																<span>{{ f2.allTotalCost.value }}</span>
															</td>
															<td scope="col" class="text-wrap" *ngFor="let y of noOfYeararray">
																<span>{{y.proposedCostTotal}}</span>
															</td>
														</tr>
													</table>
												</form>
												<table class="table">
													<tbody>
														
														<!-- <tr>
															<td>Timelines (in terms of Work Plan)</td>
															<td scope="col" class="text-wrap" colspan="2">
																<input class="form-control" type="text"
																	formControlName="Timelines" name="timelines"
																	id="timelines" class="form-control" />
															</td>
														</tr> -->
														
														<tr>
															<td scope="col" class="text-wrap" colspan="3">
																<b>Other Information</b>
															</td>
														</tr>
														<tr>
															<td scope="col" class="text-wrap">
																Annexure-I  &nbsp;&nbsp;
																<span>
																	<a href="{{documentURL}}/documentUploads/AnnexureFile/ANNEXURE-I.pdf" target="_blank">
																		Download Format
																	</a>
																</span>
															</td>
															<td>
																
															</td>
															<td>
																
															</td>
															<td>
																<div class="custom-file">
																	<input
																		type="file"
																		class="custom-file-input"
																		type="file"
																		ng2FileSelect
																		[uploader]="uploader"
																		id="file-upload-single"
																		(click)="
																			browsbuttonClick(
																				'annexureFirstFile'
																			)
																		"
																		(change) = "annexureFirstFileUpload($event)"
																		
																	/>
																	<label
																		class="custom-file-label"
																		id="SOELatter"
																		for="file-upload-single"
																		>{{ f2.DetailofAnnexureFirstFile.value }}</label
																	>
																</div>
																<sup>(Accepted format is Upload PDF, upto 5 MB)</sup>
																<span
																*ngIf="submitted && f2.DetailofAnnexureFirstFile.invalid"
																class="invalid-form"
															>
																<small
																	class="form-text text-danger"
																	*ngIf="f2.DetailofAnnexureFirstFile.errors.required"
																	>This field is required!</small
																>
																
															</span>
															</td>
									<!-- <td *ngIf="(f2?.DetailofAnnexureFirstFile.value != '')">
									<a href="{{f2?.DetailofAnnexureFirstFile.value}}"
										target="_blank"><i
											class="feather avatar-icon font-medium-1 icon-arrow-down-circle"
											title="Download Document"></i></a>
								</td> -->
														</tr>
														<tr>

															<td scope="col" class="text-wrap">
																ANNEXURE-II(A) &nbsp;&nbsp;
																<span>
																	<a href="{{documentURL}}/documentUploads/AnnexureFile/ANNEXURE-II(A).pdf" target="_blank">
																		Download Format
																	</a>
																</span>
															</td>
															<td>
																
															</td>
															<td>
																
															</td>
															<td>
																<div class="custom-file">
																	<input
																		type="file"
																		class="custom-file-input"
																		type="file"
																		ng2FileSelect
																		[uploader]="uploader"
																		id="file-upload-single"
																		(click)="browsbuttonClick('annexureSecondAFile')"
																		(change) = "annexureSecondAFileUpload($event)"
																		
																	/>
																	<label
																		class="custom-file-label"
																		id="SOELatter"
																		for="file-upload-single"
																		>{{
																			f2.DetailofAnnexureSecondAFile.value
																		}}</label
																	>
																</div>
																<sup>(Accepted format is Upload PDF, upto 5 MB)</sup>
																<span
																*ngIf="submitted && f2.DetailofAnnexureSecondAFile.invalid"
																class="invalid-form"
															>
																<small
																	class="form-text text-danger"
																	*ngIf="f2.DetailofAnnexureSecondAFile.errors.required"
																	>This field is required!</small
																>
																
															</span>
															</td>
							 	<!-- <td *ngIf="(f2?.DetailofAnnexureSecondAFile.value != '')">
									<a href="{{f2?.DetailofAnnexureSecondAFile.value}}"
										target="_blank"><i
											class="feather avatar-icon font-medium-1 icon-arrow-down-circle"
											title="Download Document"></i></a>
								</td> -->
														</tr>
														<tr>
								<td scope="col" class="text-wrap">
									ANNEXURE-II(B) &nbsp;&nbsp;
									<span>
										<a href="{{documentURL}}/documentUploads/AnnexureFile/ANNEXURE-II(B).pdf" target="_blank">
											Download Format
										</a>
									</span>
								</td>
								<td>
									
								</td>
								<td>
									
								</td>
								<td>
									<div class="custom-file">
									<input
										type="file"
										class="custom-file-input"
										type="file"
										ng2FileSelect
										[uploader]="uploader"
										id="file-upload-single"
										(click)="browsbuttonClick('annexureSecondBFile')"
										(change) = "annexureSecondBFileUpload($event)"
									/>
									<label
										class="custom-file-label"
										id="SOELatter"
										for="file-upload-single"
										>{{ f2.DetailofAnnexureSecondBFile.value }}</label
									>
									</div>
									<sup>(Accepted format is Upload PDF, upto 5 MB)</sup>
									<span
																*ngIf="submitted && f2.DetailofAnnexureSecondBFile.invalid"
																class="invalid-form"
															>
																<small
																	class="form-text text-danger"
																	*ngIf="f2.DetailofAnnexureSecondBFile.errors.required"
																	>This field is required!</small
																>
																
															</span>
								</td>
								<!-- <td *ngIf="(f2?.DetailofAnnexureSecondBFile.value != '')">
									<a href="{{f2?.DetailofAnnexureSecondBFile.value}}"
										target="_blank"><i
											class="feather avatar-icon font-medium-1 icon-arrow-down-circle"
											title="Download Document"></i></a>
								</td> -->
														</tr>

														<tr>
															<td scope="col" class="text-wrap">
																ANNEXURE-II (C)  &nbsp;&nbsp;
																<span>
																	<a href="{{documentURL}}/documentUploads/AnnexureFile/ANNEXURE-II(C).pdf" target="_blank">
																		Download Format
																	</a>
																</span>
															</td>
															<td>
																
															</td>
															<td>
																
															</td>
															<td>
																<div class="custom-file">
																	<input type="file" class="custom-file-input"
																	type="file"
																	ng2FileSelect
																	[uploader]="uploader"
																	id="file-upload-single"
																	(click)="browsbuttonClick('annexureSecondCFile')"
																	(change) = "annexureSecondCFileUpload($event)"
																	/>
																	<label
																	class="custom-file-label"
																	id="SOELatter"
																	for="file-upload-single"
																	>{{ f2.DetailofAnnexureSecondCFile.value }}</label
																	>
									
																</div>
																<sup>(Accepted format is Upload PDF, upto 5 MB)</sup>
																<span
																*ngIf="submitted && f2.DetailofAnnexureSecondCFile.invalid"
																class="invalid-form"
															>
																<small
																	class="form-text text-danger"
																	*ngIf="f2.DetailofAnnexureSecondCFile.errors.required"
																	>This field is required!</small
																>
																
															</span>
															</td>
									<!-- <td *ngIf="(f2?.DetailofAnnexureSecondCFile.value != '')">
									<a href="{{f2?.DetailofAnnexureSecondCFile.value}}"
										target="_blank"><i
											class="feather avatar-icon font-medium-1 icon-arrow-down-circle"
											title="Download Document"></i></a>
								</td> -->
														</tr>

														<tr>
															<td scope="col" class="text-wrap">
																ANNEXURE-II (D)  &nbsp;&nbsp;
																<span>
																	<a href="{{documentURL}}/documentUploads/AnnexureFile/ANNEXURE-II(D).pdf" target="_blank">
																		Download Format
																	</a>
																</span>
															</td>
															<td>
																
															</td>
															<td>
																
															</td>
															<td>
																<div class="custom-file">
																	<input type="file" class="custom-file-input"
																	type="file"
																	ng2FileSelect
																	[uploader]="uploader"
																	id="file-upload-single"
																	(click)="browsbuttonClick('annexureSecondDFile')"
																	(change) = "annexureSecondDFileUpload($event)"
																	/>
																	<label
																	class="custom-file-label"
																	id="SOELatter"
																	for="file-upload-single"
																	>{{ f2.DetailofAnnexureSecondDFile.value }}</label
																	>
									
																</div>
																<sup>(Accepted format is Upload PDF, upto 5 MB)</sup>
																<span
																*ngIf="submitted && f2.DetailofAnnexureSecondDFile.invalid"
																class="invalid-form"
															>
																<small
																	class="form-text text-danger"
																	*ngIf="f2.DetailofAnnexureSecondDFile.errors.required"
																	>This field is required!</small
																>
																
															</span>
															</td>
									<!-- <td *ngIf="(f2?.DetailofAnnexureSecondDFile.value != '')">
									<a href="{{f2?.DetailofAnnexureSecondDFile.value}}"
										target="_blank"><i
											class="feather avatar-icon font-medium-1 icon-arrow-down-circle"
											title="Download Document"></i></a>
								</td> -->
														</tr>

														<tr>
															<td scope="col" class="text-wrap">
																ANNEXURE-II (E)  &nbsp;&nbsp;
																<span>
																	<a href="{{documentURL}}/documentUploads/AnnexureFile/ANNEXURE-II(E).pdf" target="_blank">
																		Download Format
																	</a>
																</span>
															</td>
															<td>
																
															</td>
															<td>
																
															</td>
															<td>
																<div class="custom-file">
																	<input type="file" class="custom-file-input"
																	type="file"
																	ng2FileSelect
																	[uploader]="uploader"
																	id="file-upload-single"
																	(click)="browsbuttonClick('annexureSecondEFile')"
																	(change) = "annexureSecondEFileUpload($event)"
																	/>
																	<label
																	class="custom-file-label"
																	id="SOELatter"
																	for="file-upload-single"
																	>{{ f2.DetailofAnnexureSecondEFile.value }}</label
																	>
									
																</div>
																<sup>(Accepted format is Upload PDF, upto 5 MB)</sup>
																<span
																*ngIf="submitted && f2.DetailofAnnexureSecondEFile.invalid"
																class="invalid-form"
															>
																<small
																	class="form-text text-danger"
																	*ngIf="f2.DetailofAnnexureSecondEFile.errors.required"
																	>This field is required!</small
																>
																
															</span>
															</td>
									<!-- <td *ngIf="(f2?.DetailofAnnexureSecondEFile.value != '')">
									<a href="{{f2?.DetailofAnnexureSecondEFile.value}}"
										target="_blank"><i
											class="feather avatar-icon font-medium-1 icon-arrow-down-circle"
											title="Download Document"></i></a>
								</td> -->
														</tr>
													</tbody>
												</table>
											</div>
										</div>
									</div>
									
									<!-- <div class="d-flex justify-content-between">
										<button
										 *ngIf="!hideButton"
											type="button" 
											(click)="horizontalWizardStepperPrevious()"
											class="btn btn-primary btn-prev"
											rippleEffect
										>
											<i
												data-feather="arrow-left"
												class="align-middle mr-sm-25 mr-0"
											></i>
											<span class="align-middle d-sm-inline-block d-none"
												>Previous</span
											>
										</button>
										<button
											(click)="submitStep2()"
											class="btn btn-primary btn-next"
											rippleEffect
										>
											<span class="align-middle d-sm-inline-block d-none"
												>Submit</span
											>
											<i
												data-feather="arrow-right"
												class="align-middle ml-sm-25 ml-0"
											></i>
										</button>
									</div> -->
								</form>
							</div>
							<div id="format3" class="content">
								<form [formGroup]="format3" autocomplete="off">
									<div class="content-header">
										<h5 class="mb-0">
											Details of Costs of Various Components and Justification
										</h5>
										<small class="text-muted">Fill-up the Details.</small>
									</div>
									<div class="row" id="table-responsive">
										<span class="mb-2">a). Cost of Equipment</span>
										<div class="form-group col-12">
											<div class="table-responsive table-bordered">
												<form [formGroup]="equipmentForm" *ngIf="equipmentForm">
													<table class="table table-striped table-bordered">
														<thead>
															<tr>
																<th scope="col" class="text-wrap">Action</th>
																<th scope="col" class="text-wrap">Sr.</th>
																<th scope="col" class="text-wrap">
																	Name of the Equipment along with make & model
																</th>
																<th scope="col" class="text-wrap">
																	Imported/ Indigenous
																</th>
																<th scope="col" class="text-wrap">
																	Estimated Costs (in INR Currency also for
																	imported equipment)*
																</th>
																<th scope="col" colspan="2" class="text-wrap">
																	Justification
																</th>
															</tr>
														</thead>
														<tbody formArrayName="equipmentArray">
															<tr
																*ngFor="
																	let item of equipmentForm.controls
																		.equipmentArray.controls;
																	let $index = index
																"
																[formGroupName]="$index"
															>
																<td>
																	<i
																		class="fa fa-trash fa-2x"
																		(click)="deleteEquipmentRow($index)"
																		title="Delete"
																		style="cursor: pointer"
																	></i>
																</td>
																<td scope="col" class="text-wrap">
																	{{ $index + 1 }}.
																</td>
																<td>
																	<input
																		class="form-control"
																		type="text"
																		formControlName="equipmentName"
																		[ngClass]="{
																			'is-invalid':
																				equipmentForm.controls['equipmentArray']
																					.controls[$index].controls[
																					'equipmentName'
																				].touched &&
																				equipmentForm.controls['equipmentArray']
																					.controls[$index].controls[
																					'equipmentName'
																				].invalid
																		}"
																	/>
																	<span
																		*ngIf="
																			equipmentForm.controls['equipmentArray']
																				.controls[$index].controls[
																				'equipmentName'
																			].invalid
																		"
																		class="invalid-form"
																	>
																		<small
																			class="form-text text-danger"
																			*ngIf="
																				equipmentForm.controls['equipmentArray']
																					.controls[$index].controls[
																					'equipmentName'
																				].touched &&
																				equipmentForm.controls[
																					'equipmentArray'
																				].controls[$index].controls[
																					'equipmentName'
																				].hasError('required')
																			"
																		>
																			Required!
																		</small>
																		<small
										class="form-text text-danger"
										*ngIf="
										equipmentForm.controls['equipmentArray']
											.controls[$index].controls[
											'equipmentName'
										].touched &&
																				equipmentForm.controls[
																					'equipmentArray'
																				].controls[$index].controls[
																					'equipmentName'
																				].hasError('pattern')
										"
									>
										Atleast one alphanumerical value is
										required!
									</small>
																	</span>
																</td>
																<td>
																	<input
																		class="form-control"
																		type="text"
																		formControlName="importedIndigenous"
																		[ngClass]="{
																			'is-invalid':
																				equipmentForm.controls['equipmentArray']
																					.controls[$index].controls[
																					'importedIndigenous'
																				].touched &&
																				equipmentForm.controls['equipmentArray']
																					.controls[$index].controls[
																					'importedIndigenous'
																				].invalid
																		}"
																	/>
																	<span
																		*ngIf="
																			equipmentForm.controls['equipmentArray']
																				.controls[$index].controls[
																				'importedIndigenous'
																			].invalid
																		"
																		class="invalid-form"
																	>
																		<small
																			class="form-text text-danger"
																			*ngIf="
																				equipmentForm.controls['equipmentArray']
																					.controls[$index].controls[
																					'importedIndigenous'
																				].touched &&
																				equipmentForm.controls[
																					'equipmentArray'
																				].controls[$index].controls[
																					'importedIndigenous'
																				].hasError('required')
																			"
																		>
																			Required!
																		</small>
																		<small
										class="form-text text-danger"
										*ngIf="
										equipmentForm.controls['equipmentArray']
											.controls[$index].controls[
											'importedIndigenous'
										].touched &&
																				equipmentForm.controls[
																					'equipmentArray'
																				].controls[$index].controls[
																					'importedIndigenous'
																				].hasError('pattern')
										"
									>
										Atleast one alphanumerical value is
										required!
									</small>
																	</span>
																</td>
																<td>
																	<input
																		class="form-control"
																		type="text" curencyFormat
																		formControlName="estimatedCost"
																		[ngClass]="{
																			'is-invalid':
																				equipmentForm.controls['equipmentArray']
																					.controls[$index].controls[
																					'estimatedCost'
																				].touched &&
																				equipmentForm.controls['equipmentArray']
																					.controls[$index].controls[
																					'estimatedCost'
																				].invalid
																		}"
																		[mask]="
																			'^[+]?([1-9]\\d*|0)?(\\.\\d\{0,2\})?$'
																		"
																		onKeyPress="if(this.value.length==15) return false;"
																	/>
																	<span
																		*ngIf="
																			equipmentForm.controls['equipmentArray']
																				.controls[$index].controls[
																				'estimatedCost'
																			].invalid
																		"
																		class="invalid-form"
																	>
																		<small
																			class="form-text text-danger"
																			*ngIf="
																				equipmentForm.controls['equipmentArray']
																					.controls[$index].controls[
																					'estimatedCost'
																				].touched &&
																				equipmentForm.controls[
																					'equipmentArray'
																				].controls[$index].controls[
																					'estimatedCost'
																				].hasError('required')
																			"
																		>
																			Required!
																		</small>
																	</span>
																</td>
																<td>
																	<input
																		class="form-control"
																		type="text"
																		formControlName="justification"
																		[ngClass]="{
																			'is-invalid':
																				equipmentForm.controls['equipmentArray']
																					.controls[$index].controls[
																					'justification'
																				].touched &&
																				equipmentForm.controls['equipmentArray']
																					.controls[$index].controls[
																					'justification'
																				].invalid
																		}"
																	/>
																	<span
																		*ngIf="
																			equipmentForm.controls['equipmentArray']
																				.controls[$index].controls[
																				'justification'
																			].invalid
																		"
																		class="invalid-form"
																	>
																		<small
																			class="form-text text-danger"
																			*ngIf="
																				equipmentForm.controls['equipmentArray']
																					.controls[$index].controls[
																					'justification'
																				].touched &&
																				equipmentForm.controls[
																					'equipmentArray'
																				].controls[$index].controls[
																					'justification'
																				].hasError('required')
																			"
																		>
																			Required!
																		</small>
																		<small
										class="form-text text-danger"
										*ngIf="
										equipmentForm.controls['equipmentArray']
											.controls[$index].controls[
											'justification'
										].touched &&
																				equipmentForm.controls[
																					'equipmentArray'
																				].controls[$index].controls[
																					'justification'
																				].hasError('pattern')
										"
									>
										Atleast one alphanumerical value is
										required!
									</small>
																	</span>
																</td>
																<td scope="col" class="text-wrap">
																	<div class="custom-file">
																		<input
																			type="file"
																			class="custom-file-input"
																			type="file"
																			ng2FileSelect
																			[uploader]="uploader"
																			id="file-upload-single"
																			formControlName="file"
																			(click)="
																				browsArrayFileObject(
																					'costEquipmentFileList',
																					$index
																				)
																			"
																			(change)="
																				onFileChange($event,'costEquipmentFileList',$index,25)
																			"
																		/>
																		<label
																			class="custom-file-label"
																			id="SOELatter"
																			for="file-upload-single"
																			>{{
																				equipmentForm.controls["equipmentArray"]
																					.controls[$index].controls["fileName"]
																					.value
																			}}</label
																		>
																	</div>
																</td>
																<td *ngIf="(equipmentForm.controls['equipmentArray'].controls[$index].controls['costEquipmentFile'].value != '')">
																	<a href="{{equipmentForm.controls['equipmentArray'].controls[$index].controls['costEquipmentFile'].value}}" target="_blank"><i
																		class="feather avatar-icon font-medium-1 icon-arrow-down-circle"
																		title="Download Document"></i></a>
																</td>
															</tr>
															<tr>
																<td>
																	<i
																		class="fa fa-plus fa-2x"
																		(click)="addEquipmentRow()"
																		title="Add"
																		style="cursor: pointer"
																	></i>
																</td>
															</tr>
														</tbody>
													</table>
												</form>
											</div>
											<span
												>*Including transport, insurance and installation
												charges.</span
											>
										</div>
									</div>

									<div class="row" id="table-responsive">
										<span class="mb-2">b). Manpower Cost</span>
										<div class="form-group col-12">
											<div class="table-responsive table-bordered">
												<form [formGroup]="manpowerForm" *ngIf="manpowerForm">
													<table class="table table-striped table-bordered">
														<thead>
															<tr>
																<th scope="col" class="text-wrap" rowspan="2">
																	Action
																</th>
																<th scope="col" class="text-wrap" rowspan="2">
																	Sr.
																</th>
																<th scope="col" class="text-wrap" rowspan="2">
																	Designation/ Numbers
																</th>
																<th scope="col" class="text-wrap" rowspan="2">
																	Justification
																</th>
																<th scope="col" class="text-wrap" rowspan="2">
																	Monthly Salary
																</th>
																<th
																	scope="col"
																	class="text-wrap"
																	style="text-align: center"
																	[attr.colspan]="dynamicColumnCount"
																>
																	Amount (Rs.)
																</th>
																<!-- <th scope="col" class="text-wrap" rowspan="2"></th> -->
															</tr>
															<tr>
																<th scope="col" class="text-wrap"  *ngFor="let y of noOfYeararray">
																	{{y.key}}
																</th>
																<th scope="col" class="text-wrap">
																	Total
																</th>
															</tr>
														</thead>
														<tbody formArrayName="manpowerArray">
															<tr
																*ngFor="
																	let item of manpowerForm.controls
																		.manpowerArray.controls;
																	let $index = index
																"
																[formGroupName]="$index"
															>
																<td>
																	<i
																		class="fa fa-trash fa-2x"
																		(click)="deleteManpowerRow($index)"
																		title="Delete"
																		style="cursor: pointer"
																	></i>
																</td>
																<td scope="col" class="text-wrap">
																	{{ $index + 1 }}.
																</td>
																<td style="min-width: 120px">
																	<input
																		class="form-control"
																		type="text"
																		formControlName="designation"
																		[ngClass]="{
																			'is-invalid':
																				manpowerForm.controls['manpowerArray']
																					.controls[$index].controls[
																					'designation'
																				].touched &&
																				manpowerForm.controls['manpowerArray']
																					.controls[$index].controls[
																					'designation'
																				].invalid
																		}"
																	/>
																	<span
																		*ngIf="
																			manpowerForm.controls['manpowerArray']
																				.controls[$index].controls[
																				'designation'
																			].invalid
																		"
																		class="invalid-form"
																	>
																		<small
																			class="form-text text-danger"
																			*ngIf="
																				manpowerForm.controls['manpowerArray']
																					.controls[$index].controls[
																					'designation'
																				].touched &&
																				manpowerForm.controls[
																					'manpowerArray'
																				].controls[$index].controls[
																					'designation'
																				].hasError('required')
																			"
																		>
																			Required!
																		</small>
																		<small
										class="form-text text-danger"
										*ngIf="
										manpowerForm.controls['manpowerArray']
											.controls[$index].controls[
											'designation'
										].touched &&
																				manpowerForm.controls[
																					'manpowerArray'
																				].controls[$index].controls[
																					'designation'
																				].hasError('pattern')
										"
									>
										Atleast one alphanumerical value is
										required!
									</small>
																	</span>
																</td>
																<td style="min-width: 120px">
																	<input
																		class="form-control"
																		type="text"
																		formControlName="justification"
																		[ngClass]="{
																			'is-invalid':
																				manpowerForm.controls['manpowerArray']
																					.controls[$index].controls[
																					'justification'
																				].touched &&
																				manpowerForm.controls['manpowerArray']
																					.controls[$index].controls[
																					'justification'
																				].invalid
																		}"
																	/>
																	<span
																		*ngIf="
																			manpowerForm.controls['manpowerArray']
																				.controls[$index].controls[
																				'justification'
																			].invalid
																		"
																		class="invalid-form"
																	>
																		<small
																			class="form-text text-danger"
																			*ngIf="
																				manpowerForm.controls['manpowerArray']
																					.controls[$index].controls[
																					'justification'
																				].touched &&
																				manpowerForm.controls[
																					'manpowerArray'
																				].controls[$index].controls[
																					'justification'
																				].hasError('required')
																			"
																		>
																			Required!
																		</small>
																		<small
										class="form-text text-danger"
										*ngIf="
										manpowerForm.controls['manpowerArray']
											.controls[$index].controls[
											'justification'
										].touched &&
																				manpowerForm.controls[
																					'manpowerArray'
																				].controls[$index].controls[
																					'justification'
																				].hasError('pattern')
										"
									>
										Atleast one alphanumerical value is
										required!
									</small>
																	</span>
																</td>
																<td style="min-width: 120px">
																	<input
																		class="form-control"
																		type="text" curencyFormat
																		formControlName="monthlyEmoluments"
																		[ngClass]="{
																			'is-invalid':
																				manpowerForm.controls['manpowerArray']
																					.controls[$index].controls[
																					'monthlyEmoluments'
																				].touched &&
																				manpowerForm.controls['manpowerArray']
																					.controls[$index].controls[
																					'monthlyEmoluments'
																				].invalid
																		}"
																		[mask]="
																			'^[+]?([1-9]\\d*|0)?(\\.\\d\{0,2\})?$'
																		"
																		onKeyPress="if(this.value.length==15) return false;"
																		
																	/>
																	<span
																		*ngIf="
																			manpowerForm.controls['manpowerArray']
																				.controls[$index].controls[
																				'monthlyEmoluments'
																			].invalid
																		"
																		class="invalid-form"
																	>
																		<small
																			class="form-text text-danger"
																			*ngIf="
																				manpowerForm.controls['manpowerArray']
																					.controls[$index].controls[
																					'monthlyEmoluments'
																				].touched &&
																				manpowerForm.controls[
																					'manpowerArray'
																				].controls[$index].controls[
																					'monthlyEmoluments'
																				].hasError('required')
																			"
																		>
																			Required!
																		</small>
																		<small
										class="form-text text-danger"
										*ngIf="
										manpowerForm.controls['manpowerArray']
											.controls[$index].controls[
											'monthlyEmoluments'
										].touched &&
																				manpowerForm.controls[
																					'manpowerArray'
																				].controls[$index].controls[
																					'monthlyEmoluments'
																				].hasError('pattern')
										"
									>
										Atleast one alphanumerical value is
										required!
									</small>
																	</span>
																</td>
																<td style="min-width: 120px" *ngFor="let y of noOfYeararray; let $index1 = index1">
																	<input
																		class="form-control"
																		type="text" curencyFormat
																		formControlName="{{y.label}}"
																		(change)="setManPowerYearTotal($index)"
																		[mask]="'^[+]?([1-9]\\d*|0)?(\\.\\d\{0,2\})?$'"
																		onKeyPress="if(this.value.length==15) return false;"
																	/>
																</td>
																<!-- <td style="min-width: 120px">
																	<input
																		class="form-control"
																		type="text" curencyFormat
																		formControlName="year2"
																		[ngClass]="{
																			'is-invalid':
																				manpowerForm.controls['manpowerArray']
																					.controls[$index].controls['year2']
																					.touched &&
																				manpowerForm.controls['manpowerArray']
																					.controls[$index].controls['year2']
																					.invalid
																		}"
																		(change)="setManPowerYearTotal($index)"
																		[mask]="
																			'^[+]?([1-9]\\d*|0)?(\\.\\d\{0,2\})?$'
																		"
																		onKeyPress="if(this.value.length==15) return false;"
																	/>
																	<span
																		*ngIf="
																			manpowerForm.controls['manpowerArray']
																				.controls[$index].controls['year2']
																				.invalid
																		"
																		class="invalid-form"
																	>
																		<small
																			class="form-text text-danger"
																			*ngIf="
																				manpowerForm.controls['manpowerArray']
																					.controls[$index].controls['year2']
																					.touched &&
																				manpowerForm.controls[
																					'manpowerArray'
																				].controls[$index].controls[
																					'year2'
																				].hasError('required')
																			"
																		>
																			Required!
																		</small>
																	</span>
																</td>
																<td style="min-width: 120px">
																	<input
																		class="form-control"
																		type="text" curencyFormat
																		formControlName="year3"
																		[ngClass]="{
																			'is-invalid':
																				manpowerForm.controls['manpowerArray']
																					.controls[$index].controls['year3']
																					.touched &&
																				manpowerForm.controls['manpowerArray']
																					.controls[$index].controls['year3']
																					.invalid
																		}"
																		(change)="setManPowerYearTotal($index)"
																		[mask]="
																			'^[+]?([1-9]\\d*|0)?(\\.\\d\{0,2\})?$'
																		"
																		onKeyPress="if(this.value.length==15) return false;"
																	/>
																	<span
																		*ngIf="
																			manpowerForm.controls['manpowerArray']
																				.controls[$index].controls['year3']
																				.invalid
																		"
																		class="invalid-form"
																	>
																		<small
																			class="form-text text-danger"
																			*ngIf="
																				manpowerForm.controls['manpowerArray']
																					.controls[$index].controls['year3']
																					.touched &&
																				manpowerForm.controls[
																					'manpowerArray'
																				].controls[$index].controls[
																					'year3'
																				].hasError('required')
																			"
																		>
																			Required!
																		</small>
																	</span>
																</td> -->
																<td style="min-width: 120px">
																	<span>{{
																		manpowerForm.controls["manpowerArray"]
																			.controls[$index].controls["total"].value
																	}}</span>
																</td>
															</tr>
															<tr>
																<td>
																	<i
																		class="fa fa-plus fa-2x"
																		(click)="addManpowerRow()"
																		title="Add"
																		style="cursor: pointer"
																	></i>
																</td>
															</tr>
														</tbody>
													</table>
												</form>
											</div>
											<!-- <span>*Man months to be given within brackets before the budget amount.</span> -->
										</div>
									</div>

									<div class="row" id="table-responsive">
										<span class="mb-2">c). Cost of Consumables</span>
										<div class="form-group col-12">
											<div class="table-bordered">
												<form [formGroup]="consumablesForm" *ngIf="consumablesForm">
													<table class="table table-striped table-bordered">
														<thead>
															<tr>
																<th
																	scope="col"
																	class="text-wrap"
																	rowspan="2"
																>
																	Action
																</th>
																<th
																	scope="col"
																	class="text-wrap"
																	rowspan="2"
																>
																	Sr.
																</th>
																<th
																	scope="col"
																	class="text-wrap"
																	rowspan="2"
																>
																	Item
																</th>
																<th
																	scope="col"
																	class="text-wrap"
																	rowspan="2"
																>
																	Quantity
																</th>
																<th
																	scope="col"
																	class="text-wrap"
																	rowspan="2"
																>
																	Unit
																</th>
																<th
																	scope="col"
																	class="text-wrap"
																	style="text-align: center"
																	[attr.colspan]="noOfYeararray.length"
																>
																	Amount (Rs.)
																</th>
															</tr>
															<tr>
																<th scope="col" class="text-wrap"  *ngFor="let y of noOfYeararray">
																	{{y.key}}
																</th>
																<!-- <th scope="col" class="text-wrap">Total</th> -->
															</tr>
														</thead>
														<tbody formArrayName="consumablesArray">
															<tr *ngFor="
															let item of consumablesForm.controls
																.consumablesArray?.controls;
															let $index = index
														"
														[formGroupName]="$index">
																<td>
																	<i
																		class="fa fa-trash fa-2x"
																		(click)="deleteConsumablesRow($index)"
																		title="Delete"
																		style="cursor: pointer"
																	></i>
																</td>
																<td scope="col" class="text-wrap">
																	{{ $index + 1 }}.
																</td>
																<td>
																	<input
																		class="form-control"
																		type="text"
																		formControlName="item"
																		[ngClass]="{
																			'is-invalid':
																				consumablesForm.controls[
																					'consumablesArray'
																				].controls[$index].controls['item']
																					.touched &&
																				consumablesForm.controls[
																					'consumablesArray'
																				].controls[$index].controls['item']
																					.invalid
																		}"
																	/>
																	<span
																		*ngIf="
																			consumablesForm.controls[
																				'consumablesArray'
																			].controls[$index].controls['item']
																				.invalid
																		"
																		class="invalid-form"
																	>
																		<small
																			class="form-text text-danger"
																			*ngIf="
																				consumablesForm.controls[
																					'consumablesArray'
																				].controls[$index].controls['item']
																					.touched &&
																				consumablesForm.controls[
																					'consumablesArray'
																				].controls[$index].controls[
																					'item'
																				].hasError('required')
																			"
																		>
																			Required!
																		</small>
								<small
								class="form-text text-danger"
								*ngIf="
																				consumablesForm.controls[
																					'consumablesArray'
																				].controls[$index].controls['item']
																					.touched &&
																				consumablesForm.controls[
																					'consumablesArray'
																				].controls[$index].controls[
																					'item'
																				].hasError('pattern')
																			"
							>
								Atleast one alphanumerical value is
								required!
							</small>
																	</span>
																</td>
																<td>
																	<input
																		class="form-control"
																		type="text"
																		formControlName="qty"
																		[ngClass]="{
																			'is-invalid':
																				consumablesForm.controls[
																					'consumablesArray'
																				].controls[$index].controls['qty']
																					.touched &&
																				consumablesForm.controls[
																					'consumablesArray'
																				].controls[$index].controls['qty']
																					.invalid
																		}"
																		maxlength="10"
																		[mask]="'^([1-9]\\d*|0)$'"
																	/>
																	<span
																		*ngIf="
																			consumablesForm.controls[
																				'consumablesArray'
																			].controls[$index].controls['qty']
																				.invalid
																		"
																		class="invalid-form"
																	>
																		<small
																			class="form-text text-danger"
																			*ngIf="
																				consumablesForm.controls[
																					'consumablesArray'
																				].controls[$index].controls['qty']
																					.touched &&
																				consumablesForm.controls[
																					'consumablesArray'
																				].controls[$index].controls[
																					'qty'
																				].hasError('required')
																			"
																		>
																			Required!
																		</small>
																	</span>
																</td>
																<td style="min-width: 250px">
																	<ng-select
																		[items]="unitsType"
																		bindLabel="unitsTypeName"
																		bindValue="unitsTypeID"
																		[class.error]="
																			consumablesForm.controls[
																				'consumablesArray'
																			].controls[$index].controls['unit']
																				.invalid
																		"
																		(change)="setUnitName($index)"
																		formControlName="unit"
																		placeholder="Unit Type"
																	>
																	</ng-select>
																	<span
																		*ngIf="
																			consumablesForm.controls[
																				'consumablesArray'
																			].controls[$index].controls['unit']
																				.invalid
																		"
																		class="invalid-form"
																	>
																		<small
																			class="form-text text-danger"
																			*ngIf="
																				consumablesForm.controls[
																					'consumablesArray'
																				].controls[$index].controls[
																					'unit'
																				].hasError('required')
																			"
																		>
																			Required!</small
																		>
																	</span>
																</td>
																<td scope="col" class="text-wrap" *ngFor="let y of noOfYeararray; let $index1 = index1">
																	<input
																		class="form-control"
																		type="text"
																		curencyFormat
																		formControlName="{{y.label}}"
																		[mask]="'^[+]?([1-9]\\d*|0)?(\\.\\d\{0,2\})?$'"
																		onKeyPress="if(this.value.length==15) return false;"
																		(change)="setConsumablesFormFieldTotal()"
																	/>
																	
																</td>
															</tr>
														</tbody>
														<tr>
															<td scope="col">
																<i
																	class="fa fa-plus fa-2x"
																	(click)="addConsumablesRow()"
																	title="Add"
																	style="cursor: pointer"
																></i>
															</td>
															<td scope="col" class="text-wrap"></td>
															<td
																scope="col"
																colspan="3"
																class="text-wrap"
																style="text-align: right"
															>
																Total
															</td>
															<td scope="col" class="text-wrap" *ngFor="let y of noOfYeararray">
																<span>{{y.costofConsumableTotal}}</span>
															</td>
														</tr>
													</table>
												</form>
											</div>
										</div>
									</div>

									<div class="d-flex justify-content-between">
										<button
											type="button"
											(click)="horizontalWizardStepperPrevious()"
											class="btn btn-primary btn-prev"
											rippleEffect
										>
											<i
												data-feather="arrow-left"
												class="align-middle mr-sm-25 mr-0"
											></i>
											<span class="align-middle d-sm-inline-block d-none"
												>Previous</span
											>
										</button>
										<button
											(click)="submitStep3()"
											class="btn btn-primary btn-next"
											rippleEffect
										>
											<span class="align-middle d-sm-inline-block d-none"
												>Save & Next</span
											>
											<i
												data-feather="arrow-right"
												class="align-middle ml-sm-25 ml-0"
											></i>
										</button>
									</div>
								</form>
							</div>
							<div id="format4" class="content">
								<form [formGroup]="format4" autocomplete="off">
									<div class="content-header">
										<h5 class="mb-0">Proposal Format - 4</h5>
										<small class="text-muted">Fill-up the Details.</small>
									</div>
									<div class="row" id="table-responsive">
										<span class="mb-2">d). Travel Cost</span>
										<div class="form-group col-12">
											<div class="table-responsive table-bordered">
												<form [formGroup]="travelForm" *ngIf="travelForm">
													<table class="table table-striped table-bordered">
														<thead>
															<tr>
																<th scope="col" class="text-wrap" rowspan="2">
																	Action
																</th>
																<th scope="col" class="text-wrap" rowspan="2">
																	Sr.
																</th>
																<th scope="col" class="text-wrap" rowspan="2">
																	Travel (Domestic/ International)
																</th>
																<th scope="col" class="text-wrap" rowspan="2">
																	Justification
																</th>
																<th
																	scope="col"
																	class="text-wrap"
																	style="text-align: center"
																	[attr.colspan]="dynamicColumnCount"
																>
																	Amount (Rs.)
																</th>
															</tr>
															<tr>
																<th scope="col" class="text-wrap"  *ngFor="let y of noOfYeararray">
																	{{y.key}}
																</th>
																<th scope="col" class="text-wrap">Total</th>
															</tr>
														</thead>
														<tbody formArrayName="travelArray">
															<tr
																*ngFor="
																	let item of travelForm.controls.travelArray
																		.controls;
																	let $index = index
																"
																[formGroupName]="$index"
															>
																<td>
																	<i
																		class="fa fa-trash fa-2x"
																		(click)="deleteTravelRow($index)"
																		title="Delete"
																		style="cursor: pointer"
																	></i>
																</td>
																<td scope="col" class="text-wrap">
																	{{ $index + 1 }}.
																</td>
																<td style="min-width: 120px">
																	<input
																		class="form-control"
																		type="text"
																		formControlName="title"
																		[ngClass]="{
																			'is-invalid':
																				travelForm.controls['travelArray']
																					.controls[$index].controls['title']
																					.touched &&
																				travelForm.controls['travelArray']
																					.controls[$index].controls['title']
																					.invalid
																		}"
																	/>
																	<span
																		*ngIf="
																			travelForm.controls['travelArray']
																				.controls[$index].controls['title']
																				.invalid
																		"
																		class="invalid-form"
																	>
																		<small
																			class="form-text text-danger"
																			*ngIf="
																				travelForm.controls['travelArray']
																					.controls[$index].controls['title']
																					.touched &&
																				travelForm.controls[
																					'travelArray'
																				].controls[$index].controls[
																					'title'
																				].hasError('required')
																			"
																		>
																			Required!
																		</small>
																		<small
										class="form-text text-danger"
										*ngIf="
										travelForm.controls['travelArray']
											.controls[$index].controls['title']
											.touched &&
											travelForm.controls[
											'travelArray'
											].controls[$index].controls[
											'title'
											].hasError('pattern')
										"
									>
										Atleast one alphanumerical value is
										required!
									</small>
																	</span>
																</td>
																<td style="min-width: 120px">
																	<input
																		class="form-control"
																		type="text"
																		formControlName="justification"
																		[ngClass]="{
																			'is-invalid':
																				travelForm.controls['travelArray']
																					.controls[$index].controls[
																					'justification'
																				].touched &&
																				travelForm.controls['travelArray']
																					.controls[$index].controls[
																					'justification'
																				].invalid
																		}"
																	/>
																	<span
																		*ngIf="
																			travelForm.controls['travelArray']
																				.controls[$index].controls[
																				'justification'
																			].invalid
																		"
																		class="invalid-form"
																	>
																		<small
																			class="form-text text-danger"
																			*ngIf="
																				travelForm.controls['travelArray']
																					.controls[$index].controls[
																					'justification'
																				].touched &&
																				travelForm.controls[
																					'travelArray'
																				].controls[$index].controls[
																					'justification'
																				].hasError('required')
																			"
																		>
																			Required!
																		</small>
																		<small
										class="form-text text-danger"
										*ngIf="
										travelForm.controls['travelArray']
											.controls[$index].controls[
											'justification'
										].touched &&
																				travelForm.controls[
																					'travelArray'
																				].controls[$index].controls[
																					'justification'
																				].hasError('pattern')
										"
									>
										Atleast one alphanumerical value is
										required!
									</small>
																	</span>
																</td>
																<td style="min-width: 120px" *ngFor="let y of noOfYeararray; let $index1 = index1">
																	<input
																		class="form-control"
																		type="text" curencyFormat
																		formControlName="{{y.label}}"
																		(change)="setTravelCostTotal($index)"
																		[mask]="'^[+]?([1-9]\\d*|0)?(\\.\\d\{0,2\})?$'"
																		onKeyPress="if(this.value.length==15) return false;"
																	/>
																</td>
																<td style="min-width: 120px">
																	<span>{{
																		travelForm.controls["travelArray"].controls[
																			$index
																		].controls["total"].value
																	}}</span>
																</td>
															</tr>
															<tr>
																<td>
																	<i
																		class="fa fa-plus fa-2x"
																		(click)="addTravelRow()"
																		title="Add"
																		style="cursor: pointer"
																	></i>
																</td>
															</tr>
														</tbody>
													</table>
												</form>
											</div>
										</div>
									</div>
									<div class="d-flex justify-content-between">
										<button
											type="button"
											(click)="horizontalWizardStepperPrevious()"
											class="btn btn-primary btn-prev"
											rippleEffect
										>
											<i
												data-feather="arrow-left"
												class="align-middle mr-sm-25 mr-0"
											></i>
											<span class="align-middle d-sm-inline-block d-none"
												>Previous</span
											>
										</button>
										<!-- <button (click)="horizontalWizardStepperNext(format4)" class="btn btn-primary btn-next"
						rippleEffect>
						<span class="align-middle d-sm-inline-block d-none">Save & Next</span>
						<i data-feather="arrow-right" class="align-middle ml-sm-25 ml-0"></i>
					</button> -->
										<!-- <button
											class="btn btn-success btn-submit"
											[disabled]="isDisabled"
											rippleEffect
											(click)="onSubmit()"
										>
											Submit
										</button> -->
									</div>
								</form>
							</div>
							<!-- <div id="format5" class="content">
				<form [formGroup]="format5" autocomplete="off" (ngSubmit)="onSubmit()">
					<div class="content-header">
					<h5 class="mb-0">Certificate from the Principal Investigator and Grantee organization (On the letter
						head of the Organization)</h5>
					</div>
					<div class="row">
					<div class="form-group col-md-6"></div>
					<div class="form-group col-md-6"></div>
					</div>
					<div class="d-flex justify-content-between">
					<button type="button" (click)="horizontalWizardStepperPrevious()" class="btn btn-primary btn-prev"
						rippleEffect>
						<i data-feather="arrow-left" class="align-middle mr-sm-25 mr-0"></i>
						<span class="align-middle d-sm-inline-block d-none">Previous</span>
					</button>
					<button class="btn btn-success btn-submit" rippleEffect (click)="onSubmit()">Submit</button>
					</div>
				</form>
				</div> -->
						</div>
					</div>
				</div>
			<!-- </div> -->
		</section>
	</div>
</div>
